import BaseModal, {
	ModalContainerProps,
	ModalTitleProps,
} from 'src/components/primitives/BaseModal/BaseModal';
import { cm } from 'src/utils/classNames';

interface BottomDrawerContainerProps extends Omit<
	ModalContainerProps,
	'onClose'
> {
	/**
	 * Used to close the drawer. Get from `useCloseBottomDrawer`.
	 */
	closeDrawer: () => void;
	/**
	 * Used to apply the closing animation styles. Get from `useCloseBottomDrawer`.
	 */
	isDrawerClosing: boolean;
}

function BottomDrawerContainer({
	className,
	closeDrawer,
	isDrawerClosing,
	...rest
}: BottomDrawerContainerProps) {
	return (
		<BaseModal.Container
			className={cm(
				'h-auto max-h-[90dvh] w-full max-w-none rounded-t-xl bg-container-bg',
				'border-t border-input-border',
				'fixed right-0 bottom-0 left-0',
				isDrawerClosing ? 'animate-slide-down' : 'animate-slide-up',
				className
			)}
			onClose={closeDrawer}
			{...rest}
		/>
	);
}

interface BottomDrawerTitleProps<T extends string>
	extends
		Pick<BottomDrawerContainerProps, 'closeDrawer'>,
		Omit<ModalTitleProps<T>, 'onClose'> {}

function BottomDrawerTitle<T extends string>({
	closeDrawer,
	...rest
}: BottomDrawerTitleProps<T>) {
	return (
		<BaseModal.Title onClose={closeDrawer} {...(rest as ModalTitleProps<T>)} />
	);
}

export default {
	/**
	 * Renders a drawer that slides up from the bottom of the screen on mobile.
	 *
	 * Use with `useCloseBottomDrawer` to ensure the drawer closes with a transition.
	 */
	Container: BottomDrawerContainer,
	Title: BottomDrawerTitle,
	Body: BaseModal.Body,
	Footer: BaseModal.Footer,
};
